const EditIconWithColor = () => {
  return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_612_4627"
        //   style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path d="M24 0H0V24H24V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_612_4627)">
          <path
            d="M3.61211 11.3994C2.08445 12.8188 1.83414 13.43 1.83414 13.43C1.83414 13.43 0.294298 16.7919 -7.75175e-05 22.251C-0.0124876 22.4822 0.0240671 22.7135 0.107195 22.9296C0.190322 23.1457 0.31815 23.3419 0.482312 23.5052C0.646474 23.6685 0.843272 23.7953 1.05983 23.8773C1.27638 23.9594 1.50782 23.9947 1.73898 23.9811C6.91399 23.6872 10.072 22.3733 10.5079 22.1821C11.2185 21.9027 12.3749 20.5785 12.3749 20.5785L9.3843 14.6343L3.61211 11.3994Z"
            fill="#F2575C"
          />
          <path
            d="M2.67188 12.335C2.91328 12.0739 3.22077 11.7631 3.61265 11.3975C4.66827 10.2354 5.96016 8.87794 7.54453 7.29357C10.1606 4.67747 12.1622 2.85403 13.6786 1.58372C14.5885 0.821723 15.6822 0.31147 16.8508 0.103802C18.0193 -0.103866 19.2218 -0.00169742 20.3386 0.400129C20.3386 0.400129 22.6247 1.09294 23.573 3.5956C24.4167 5.82169 24.0103 8.40122 22.4086 10.3137C21.1383 11.8301 19.3148 13.8293 16.6987 16.4478C15.0141 18.1325 13.5863 19.4867 12.3769 20.5775C12.0942 20.8964 11.7955 21.2009 11.482 21.4897C11.482 21.4897 10.5103 18.1789 7.89328 15.5661C5.37 13.0479 2.67188 12.335 2.67188 12.335Z"
            fill="#183883"
          />
          <path
            d="M18.6919 5.6623C18.6947 3.7133 18.2597 1.78856 17.4188 0.0302734C16.0429 0.155415 14.7382 0.698278 13.6796 1.58605C12.1632 2.85637 10.1639 4.6798 7.54551 7.2959C5.96113 8.88027 4.66926 10.2378 3.61363 11.3998C3.22176 11.7636 2.91426 12.0743 2.67285 12.3373C2.67285 12.3373 5.37004 13.0503 7.89238 15.5684C8.63253 16.3138 9.28706 17.1395 9.84379 18.0303C14.9888 16.2776 18.6919 11.4026 18.6919 5.6623Z"
            fill="#5170CD"
          />
        </g>
      </svg>
  );
};
export default EditIconWithColor;
